module.exports = __webpack_public_path__ + "img/placeholder-landscape.dc9b55c.jpg";